var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"id":"test"}},[_c('div',{staticClass:"word"},[_c('markeractivityWord')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }